// extracted by mini-css-extract-plugin
export default {"tabs":"ingredients-tab_tabs__syLIY"};